import { RNG } from '../domain/types.ts';

/**
 * Linear Congruential Generator (LCG) đơn giản, deterministic và siêu nhẹ.
 * Dùng cho gameplay logic, unit tests và replay simulation.
 */
export class DeterministicRNG implements RNG {
  private state: number;

  constructor(seed = 1337) {
    this.state = seed >>> 0;
    if (this.state === 0) {
      this.state = 1337;
    }
  }

  public next(): number {
    // Numerical Recipes LCG parameters
    this.state = (Math.imul(1664525, this.state) + 1013904223) >>> 0;
    return this.state / 4294967296;
  }

  public nextRange(min: number, max: number): number {
    return min + this.next() * (max - min);
  }

  public nextInt(min: number, max: number): number {
    return Math.floor(this.nextRange(min, max + 1));
  }

  public getSeed(): number {
    return this.state;
  }
}
